import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import BottomNavigation from "../Components/BottomNavigation";
import TopNavigation from "../Components/TopNavigation";
import SocialMediaPost from "../Components/SocialMediaPost";
import { FiMapPin } from "react-icons/fi";

const Home = ({ locality }) => {
  const [restaurants, setRestaurants] = useState([]);
  const [location, setLocation] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const loaderRef = useRef(null);

  useEffect(() => {
    const loca = localStorage.getItem("location");
    setLocation(loca);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        if (location) {
          loaderRef.current.style.display = "block"; // Show the loader

          const response = await axios.get(
            `https://foodie-read.onrender.com/api/location/restaurants?location=${location}&page=1`,
            config
          );

          setRestaurants(response.data.restaurants);
          setDataLoaded(true); // Set dataLoaded to true after fetching the data
          loaderRef.current.style.display = "none"; // Hide the loader
        }
      } catch (error) {
        console.error("Error fetching restaurants:", error);
      }
    };

    fetchData();
  }, [location]);

  console.log(restaurants);

  const handlePostClick = (postId) => {
    console.log("Clicked post ID:", postId);
    // Perform any desired actions with the post ID
  };

  const profileImgs = [
    "Cali",
    "George",
    "Milo",
    "Bandit",
    "Sheba",
    "Kitty",
    "Baby",
    "Socks",
    "Jasper",
    "Snuggles",
    "Pumpkin",
    "Boo",
    "Peanut",
    "Zoe",
    "Scooter",
    "Annie",
    "Smokey",
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <TopNavigation />
      <div className="absolute top-0 left-0 flex items-center mt-20 ml-4 z-[-1]">
        <FiMapPin className="h-5 w-5 text-red-600 mr-0.5" />
        <span className="text-base mt-0.5 ml-0.5 font-bold text-gray-700 tracking-wide">
          {location}
        </span>
      </div>

      <div className="flex flex-col flex-grow items-center justify-center py-20 mt-12 px-1">
        {dataLoaded && restaurants.length === 0 ? (
          <div className="text-gray-600 text-lg font-semibold mb-4">
            No posts for your current location.
          </div>
        ) : (
          <div className="space-y-10">
            {restaurants.map((restaurant) => {
              // Generate a random index to select a random profile image
              const randomIndex = Math.floor(
                Math.random() * profileImgs.length
              );
              const randomProfileImg = profileImgs[randomIndex];

              // Format the user name to have capitalized words
              const u_name =
                restaurant && restaurant.userName
                  ? restaurant.userName
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")
                  : "";

              // Render the SocialMediaPost component with the restaurant data
              return (
                <SocialMediaPost
                  key={restaurant._id}
                  userName={u_name}
                  splDish={restaurant.splDish}
                  restaurantName={restaurant.restaurantName}
                  img={restaurant.img}
                  cost={restaurant.cost}
                  rating={restaurant.rating}
                  profilePic={`https://api.dicebear.com/6.x/pixel-art/svg?seed=${randomProfileImg}`}
                  postId={restaurant._id} // Replace "postId" with the actual post ID property
                  onClick={handlePostClick}
                  className="mr-4 mb-4"
                />
              );
            })}
          </div>
        )}

        <div
          ref={loaderRef}
          className="w-12 h-12 animate-spin rounded-full border-4 border-solid border-red-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          style={{ display: "none" }}
        ></div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Home;
